import requestService from './requestService';

const endpoints = {
  getTranslations: 'customer/translations',
  getTranslation: 'customer/translation',
  getInterpreterTranslations: 'translator/translations',
  getInterpreterTranslation: 'translator/translation',
};

const serviceRequest = async (fn) => {
  try {
    return await fn();
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getTranslations = async () => {
  return serviceRequest(() =>
    requestService.get(endpoints.getTranslations, null, { apiType: 'platform' })
  );
};

export const getInterpreterTranslations = async () => {
  return serviceRequest(() =>
    requestService.get(endpoints.getInterpreterTranslations, null, { apiType: 'platform' })
  );
};

export const getTranslation = async (id) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.get(`${endpoints.getTranslation}/${encodeURIComponent(id)}`, null, { apiType: 'platform' })
  );
};

export const getInterpreterTranslation = async (id) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.get(`${endpoints.getInterpreterTranslation}/${encodeURIComponent(id)}`, null, { apiType: 'platform' })
  );
};

export const downloadTranslationSourceFiles = async (id) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.postWithJson(`translator/translation/${encodeURIComponent(id)}/download`, null, {}, { apiType: 'platform' })
  );
};

export const getTranslatedFileUploadUrl = async (id, { filename, fileSize, contentType }) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.postWithJson(
      `translator/translation/${encodeURIComponent(id)}/translated-file/presigned-url`,
      null,
      { filename, fileSize, contentType },
      { apiType: 'platform' }
    )
  );
};

export const confirmTranslatedFileUpload = async (id, attachmentId) => {
  if (!id) throw new Error('Translation ID is required');
  if (!attachmentId) throw new Error('Attachment ID is required');
  return serviceRequest(() =>
    requestService.postWithJson(
      `translator/translation/${encodeURIComponent(id)}/translated-file/confirm`,
      null,
      { attachmentId },
      { apiType: 'platform' }
    )
  );
};

export const deleteTranslatedFile = async (id, attachmentId) => {
  if (!id) throw new Error('Translation ID is required');
  if (!attachmentId) throw new Error('Attachment ID is required');
  return serviceRequest(() =>
    requestService.delete(`translator/translation/${encodeURIComponent(id)}/translated-file/${encodeURIComponent(attachmentId)}`, { apiType: 'platform' })
  );
};

export const completeTranslation = async (id) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.putWithJson(`translator/translation/${encodeURIComponent(id)}/complete`, null, null, { apiType: 'platform' })
  );
};
